// Flow-aware navigation hook for A/B testing
// Provides navigation functions that route differently based on flow type

import { useNavigate } from 'react-router-dom';
import { useOrderStore } from '@/stores/orderStore';

export function useFlowNavigation() {
  const navigate = useNavigate();
  const flowType = useOrderStore((state) => state.flowType);

  // Navigate from Property screens (ServiceAvailable, PropertyConfirmation)
  // Flow A: Property → Personal Info
  // Flow B: Property → Utilities
  const navigateFromProperty = () => {
    if (flowType === 'B') {
      navigate('/utilities');
    } else {
      navigate('/personal-info');
    }
  };

  // Navigate from Personal Info
  // Flow A: Personal Info → Utilities
  // Flow B: Personal Info → Plan Options (if plans selected) or Checkout
  const navigateFromPersonalInfo = (planIds?: string[]) => {
    if (flowType === 'B') {
      // In Flow B, Personal Info comes after Utilities, so go to checkout/plan-options
      if (planIds && planIds.length > 0) {
        navigate(`/plan-options/${planIds[0]}`);
      } else {
        navigate('/checkout');
      }
    } else {
      // In Flow A, Personal Info → Utilities
      navigate('/utilities');
    }
  };

  // Navigate from Utilities Selection
  // Flow A: Utilities → Plan Options (if plans selected) or Checkout
  // Flow B: Utilities → Personal Info
  const navigateFromUtilities = (planIds: string[]) => {
    if (flowType === 'B') {
      // In Flow B, Utilities → Personal Info
      navigate('/personal-info');
    } else {
      // In Flow A, Utilities → Plan Options or Checkout
      if (planIds.length > 0) {
        navigate(`/plan-options/${planIds[0]}`);
      } else {
        navigate('/checkout');
      }
    }
  };

  return {
    navigateFromProperty,
    navigateFromPersonalInfo,
    navigateFromUtilities,
    flowType,
  };
}
